import { Dropdown } from "react-bootstrap";
import { LoyaltyLevelModel } from "../../models";

type Props = {
  loyaltyLevels: LoyaltyLevelModel[];
  loyaltyPointsUsed: string;
  isDisabled?: boolean;
  onSelectChange: (value: string) => void;
};

const formatBenefit = (item: LoyaltyLevelModel): string => {
  const type = item.level_benefit_type?.toLowerCase();
  if (type === "percent") return `${item.level_benefit}% Off`;
  if (type === "discount") return `$${item.level_benefit}`;
  return item.level_benefit;
};

const BenefitBadge: React.FC<{ item: LoyaltyLevelModel }> = ({ item }) => (
  <span
    style={{
      fontSize: "0.72rem",
      fontWeight: 600,
      padding: "2px 8px",
      borderRadius: 20,
      background: "rgba(var(--brand-primary-soft-rgb), 0.14)",
      color: "var(--brand-primary)",
      whiteSpace: "nowrap",
    }}
  >
    {formatBenefit(item)}
  </span>
);

const PayWithLoyalty: React.FC<Props> = ({
  loyaltyLevels = [],
  loyaltyPointsUsed,
  isDisabled = false,
  onSelectChange,
}) => {
  if (loyaltyLevels.length === 0) return <></>;

  const selected = loyaltyLevels.find(
    (item) => String(item.points) === loyaltyPointsUsed,
  );

  return (
    <div className="choose_payment_row2 align-items-center">
      <label>
        {/* <input
          type="checkbox"
          id="pay_with_loyalty"
          name="pay_with_loyalty"
          onChange={handleChange}
          checked={isChecked}
          disabled={isDisabled}
        /> */}
        <span>
          <strong>Pay with Loyalty Points</strong>
          <span>Redeem points & get instant discount</span>
        </span>
      </label>

      <div className="choose_payment_select">
        <Dropdown
          className="rounded"
          onSelect={(value) => value !== null && onSelectChange(value)}
        >
          <Dropdown.Toggle
            as="div"
            role="button"
            className={`d-flex align-items-center justify-content-between gap-2 ${isDisabled ? "opacity-50 pe-none" : ""}`}
            style={{
              border: "1px solid var(--border-soft)",
              borderRadius: 5,
              padding: "8px 12px",
              cursor: "pointer",
              fontSize: "var(--fsize-1)",
              color: "var(--text-primary)",
              background: "var(--bg-surface, #fff)",
              userSelect: "none",
            }}
          >
            {loyaltyPointsUsed === "0" ? (
              <span style={{ color: "var(--text-muted, #888)" }}>
                Don't redeem points
              </span>
            ) : selected ? (
              <span className="d-flex align-items-center gap-2">
                <span style={{ fontWeight: 600 }}>
                  {selected.points} points
                </span>
                <BenefitBadge item={selected} />
              </span>
            ) : (
              <span style={{ color: "var(--text-muted, #888)" }}>
                Select points
              </span>
            )}
          </Dropdown.Toggle>

          <Dropdown.Menu
            className="w-100 p-1 loyalty-dropdown-menu"
            style={{
              boxShadow: "0 4px 16px rgba(var(--brand-primary-soft-rgb), 0.18)",
              border: "1px solid var(--border-light)",
              borderRadius: 8,
            }}
          >
            <Dropdown.Item
              eventKey="0"
              className="rounded"
              style={{
                padding: "8px 12px",
                background:
                  loyaltyPointsUsed === "0"
                    ? "rgba(var(--brand-primary-soft-rgb), 0.10)"
                    : undefined,
              }}
            >
              <div className="d-flex align-items-center justify-content-between gap-2">
                <span
                  style={{
                    color: "var(--text-muted, #888)",
                  }}
                >
                  Don't redeem points
                </span>
              </div>
            </Dropdown.Item>

            {loyaltyLevels.map((item) => {
              const isActive = String(item.points) === loyaltyPointsUsed;
              return (
                <Dropdown.Item
                  key={item.level_id}
                  eventKey={String(item.points)}
                  className="rounded"
                  style={{
                    padding: "8px 12px",
                    background: isActive
                      ? "rgba(var(--brand-primary-soft-rgb), 0.10)"
                      : undefined,
                  }}
                >
                  <div className="d-flex align-items-center justify-content-between gap-2">
                    <span className="d-flex align-items-center gap-2">
                      <span style={{ fontWeight: isActive ? 600 : 400 }}>
                        {item.points} points
                      </span>
                    </span>
                    <span className="d-flex align-items-center gap-2">
                      <BenefitBadge item={item} />
                    </span>
                  </div>
                </Dropdown.Item>
              );
            })}
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </div>
  );
};

export default PayWithLoyalty;
